<ng-container *ngIf="checkError else formBlock">
  <mat-error i18n>Error on get material list.</mat-error>
</ng-container>

<ng-template #formBlock>
  <div *ngIf="selected !== null else listBlock">

    <div>
      <mat-toolbar color="primary" class="app-cost-element-toolbar mat-elevation-z6">
        <button mat-icon-button (click)="selected = null">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span>{{selected.name | translation:ITEM_NAMES}}</span>
      </mat-toolbar>
    </div>
    <app-cost-element-form [element]="selected" (elementChange)="update($event)"></app-cost-element-form>

  </div>
</ng-template>

<ng-template #listBlock>
  <div *ngIf="elements" class="app-cost-elements-list">

    <mat-form-field class="app-block" appearance="outline">
      <mat-label i18n>Search</mat-label>
      <input matInput i18n-placeholder placeholder="Find by code, class or description" [(ngModel)]="searchTerm">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-list class="app-material-list">
      <mat-list-item *ngFor="let element of elements |  orderBy: 'name' | costFilter: searchTerm ; let index = index">
        <p matLine>{{element.name | translation:ITEM_NAMES}}</p>
        <div matLine>
          <span fxFlex>
            {{element.cost | number:'1.2'}}
            <small i18n>per {{element.measure_unit | translation:UNITS}}</small>
          </span>
          <span fxFlex>
            {{element.installation_cost | number:'1.2'}}
            <small i18n>per installation</small>
          </span>
        </div>
        <button mat-icon-button (click)="edit(element)">
          <mat-icon>edit</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>

    <mat-card *ngIf="searchTerm && !(elements | costFilter: searchTerm)?.length" i18n>
      Dit not find any results matching.
    </mat-card>

    <mat-card *ngIf="elements && elements.length === 0" i18n>
      This material list is empty.
    </mat-card>

  </div>
  <mat-action-row>
    <button mat-raised-button color="primary" (click)="finish()" i18n>SAVE</button>
  </mat-action-row>
</ng-template>
